/**
 * This file is AUTO GENERATED by [msw-auto-mock](https://github.com/zoubingwu/msw-auto-mock)
 * Feel free to commit/edit it as you need.
 */
/* eslint-disable */
/* tslint:disable */
import {http, HttpResponse} from 'msw';
import {faker} from '@faker-js/faker';
import {setupWorker} from 'msw/browser';

faker.seed(1);

const baseURL = '';
const MAX_ARRAY_LENGTH = 20;

let i = 0;
const next = () => {
  if (i === Number.MAX_SAFE_INTEGER - 1) {
    i = 0;
  }
  return i++;
};

export const handlers = [
  http.post(`${baseURL}/auth/token`, () => {
    const resultArray = [
      [getPostAuthToken200Response(), { status: 200 }],
      [getPostAuthToken401Response(), { status: 401 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/auth/token/refresh`, () => {
    const resultArray = [
      [getPostAuthTokenRefresh200Response(), { status: 200 }],
      [getPostAuthTokenRefresh401Response(), { status: 401 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/health-check/mongo-connection`, () => {
    const resultArray = [
      [null, { status: 200 }],
      [null, { status: 500 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/health-check/redis-connection`, () => {
    const resultArray = [
      [null, { status: 200 }],
      [null, { status: 500 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/auth/business-user/token`, () => {
    const resultArray = [
      [getPostAuthBusinessUserToken200Response(), { status: 200 }],
      [getPostAuthBusinessUserToken400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/auth/business-user/code`, () => {
    const resultArray = [
      [getPostAuthBusinessUserCode200Response(), { status: 200 }],
      [getPostAuthBusinessUserCode400Response(), { status: 400 }],
      [getPostAuthBusinessUserCode404Response(), { status: 404 }],
      [getPostAuthBusinessUserCode429Response(), { status: 429 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/auth/business-user/trade`, () => {
    const resultArray = [
      [getGetAuthBusinessUserTrade200Response(), { status: 200 }],
      [getGetAuthBusinessUserTrade400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/auth/private-customer/token`, () => {
    const resultArray = [
      [getPostAuthPrivateCustomerToken200Response(), { status: 200 }],
      [getPostAuthPrivateCustomerToken400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/auth/private-customer/code`, () => {
    const resultArray = [
      [getPostAuthPrivateCustomerCode200Response(), { status: 200 }],
      [getPostAuthPrivateCustomerCode400Response(), { status: 400 }],
      [getPostAuthPrivateCustomerCode404Response(), { status: 404 }],
      [getPostAuthPrivateCustomerCode429Response(), { status: 429 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.get(`${baseURL}/auth/private-customer/trade`, () => {
    const resultArray = [
      [getGetAuthPrivateCustomerTrade200Response(), { status: 200 }],
      [getGetAuthPrivateCustomerTrade400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/api/webhooks/stripe/event`, () => {
    const resultArray = [
      [null, { status: 200 }],
      [getPostAppWebhookStripeEvent400Response(), { status: 400 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
  http.post(`${baseURL}/api/webhooks/sumsub`, () => {
    const resultArray = [
      [null, { status: 200 }],
      [getPostAppWebhookSumsub400Response(), { status: 400 }],
      [getPostAppWebhookSumsub403Response(), { status: 403 }],
    ];

    return HttpResponse.json(...resultArray[next() % resultArray.length]);
  }),
];

export function getPostAuthToken200Response() {
  return { token: 'nesciunt', refresh_token: 'cenaculum' };
}

export function getPostAuthToken401Response() {
  return { code: 8447923293519872, message: 'torrens' };
}

export function getPostAuthTokenRefresh200Response() {
  return { token: 'sequi', refresh_token: 'varius' };
}

export function getPostAuthTokenRefresh401Response() {
  return { code: 2425469148332032, message: 'acervus' };
}

export function getPostAuthBusinessUserToken200Response() {
  return { token: 'conduco', isNewUser: true };
}

export function getPostAuthBusinessUserToken400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      { field: 'input', errors: ['Input is invalid!'] },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
    ],
  };
}

export function getPostAuthBusinessUserCode200Response() {
  return { token: 'varietas', refresh_token: 'theca' };
}

export function getPostAuthBusinessUserCode400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      { field: 'input', errors: ['Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      { field: 'input', errors: ['Input is invalid!', 'Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getPostAuthBusinessUserCode404Response() {
  return { code: 2676415944196096, message: 'sperno' };
}

export function getPostAuthBusinessUserCode429Response() {
  return { code: 1835030234005504, message: 'solus' };
}

export function getGetAuthBusinessUserTrade200Response() {
  return { token: 'sustineo', isNewUser: true };
}

export function getGetAuthBusinessUserTrade400Response() {
  return { code: 3651920591847424, message: 'conicio' };
}

export function getPostAuthPrivateCustomerToken200Response() {
  return { token: 'vito', isNewUser: true };
}

export function getPostAuthPrivateCustomerToken400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getPostAuthPrivateCustomerCode200Response() {
  return { token: 'varius', refresh_token: 'repellat' };
}

export function getPostAuthPrivateCustomerCode400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: ['Input is invalid!', 'Input is invalid!', 'Input is invalid!'],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      { field: 'input', errors: ['Input is invalid!', 'Input is invalid!'] },
    ],
  };
}

export function getPostAuthPrivateCustomerCode404Response() {
  return { code: 1005160977399808, message: 'conscendo' };
}

export function getPostAuthPrivateCustomerCode429Response() {
  return { code: 6400805110284288, message: 'amo' };
}

export function getGetAuthPrivateCustomerTrade200Response() {
  return { token: 'vacuus', isNewUser: true };
}

export function getGetAuthPrivateCustomerTrade400Response() {
  return { code: 3910824598962176, message: 'spargo' };
}

export function getPostAppWebhookStripeEvent400Response() {
  return { code: 3137321916432384, message: 'theatrum' };
}

export function getPostAppWebhookSumsub400Response() {
  return {
    code: 400,
    message: 'Validation error',
    type: 'VALIDATION_ERROR',
    fields: [
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      { field: 'input', errors: ['Input is invalid!'] },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
      {
        field: 'input',
        errors: [
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
          'Input is invalid!',
        ],
      },
    ],
  };
}

export function getPostAppWebhookSumsub403Response() {
  return { code: 931505559830528, message: 'bellicus' };
}

// This configures a Service Worker with the given request handlers.
export const startWorker = () => {
  const worker = setupWorker(...handlers);
  worker.start();
};
